import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67210430"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-fluid formgrid grid" }
const _hoisted_2 = { class: "field col-12 lg:col-9" }
const _hoisted_3 = { class: "field col-12 lg:col-3 text-right" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"display":"block"} }, " ", -1))
const _hoisted_5 = {
  key: 0,
  class: "col-12"
}
const _hoisted_6 = {
  key: 1,
  class: "col-12"
}
const _hoisted_7 = { class: "employee-name" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "employee-fiscalcode" }
const _hoisted_10 = {
  key: 0,
  class: "badge status-red"
}
const _hoisted_11 = {
  key: 1,
  class: "badge status-blue"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "badge status-green"
}
const _hoisted_14 = {
  key: 2,
  class: "badge status-orange"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.handleSubmit()), ["prevent"])),
    onKeydown: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleKeydown($event)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("statEmployeeLastExamination.company")), 1),
        _createVNode(_component_Dropdown, {
          filter: true,
          modelValue: _ctx.companyId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyId) = $event)),
          options: _ctx.companies,
          onChange: _ctx.dataChanged,
          optionLabel: "name",
          optionValue: "id",
          placeholder: "-"
        }, null, 8, ["modelValue", "options", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_Button, {
          label: _ctx.t('buttons.search'),
          icon: "pi pi-search",
          type: "submit",
          class: "p-button-primary p-uppercase"
        }, null, 8, ["label"])
      ]),
      (_ctx.showResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_Divider)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_DataTable, {
              dataKey: "id",
              responsiveLayout: "scroll",
              showGridlines: "",
              sortField: "fullName",
              sortOrder: 1,
              stripedRows: "",
              value: _ctx.results
            }, {
              empty: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("gen.noData")), 1)
              ]),
              loading: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("gen.loading")), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "employee",
                  header: _ctx.t('statEmployeeLastExamination.fullName'),
                  headerStyle: "width: 60%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(data[field].fullName ?? "-"), 1),
                    _hoisted_8,
                    _createElementVNode("span", _hoisted_9, _toDisplayString(data[field].fiscalCode ?? "-"), 1)
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "lastExamination",
                  header: _ctx.t('statEmployeeLastExamination.lastExamination'),
                  bodyClass: "text-center",
                  headerStyle: "width: 20%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    (data[field] == undefined)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.t("statEmployeeLastExamination.noExamination")), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.d(data[field].date, "shortDate")), 1))
                  ]),
                  _: 1
                }, 8, ["header"]),
                _createVNode(_component_Column, {
                  field: "lastExamination",
                  header: _ctx.t('statEmployeeLastExamination.nextExpiration'),
                  bodyClass: "text-center",
                  headerStyle: "width: 20%"
                }, {
                  body: _withCtx(({ data, field }) => [
                    (data[field] == undefined)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, "-"))
                      : (_ctx.compareAsc(data[field].ending.nextExaminationDate, new Date()) > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.d(data[field].ending.nextExaminationDate, "shortDate")), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.d(data[field].ending.nextExaminationDate, "shortDate")), 1))
                  ]),
                  _: 1
                }, 8, ["header"])
              ]),
              _: 1
            }, 8, ["value"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 32))
}